import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { MdCheckCircle, MdErrorOutline } from "react-icons/md";
import { formatItemLabel } from "./utils";

const ResultDetails = ({ submittedPayload, payloadLabels }) => {
  if (!submittedPayload) return null;

  const labels = payloadLabels[submittedPayload.item] || {};
  const entries = Object.entries(submittedPayload).filter(
    ([key]) => key !== "item",
  );

  return (
    <VStack spacing="8px" align="stretch" w="100%" mt="8px">
      {entries.map(([key, value]) => (
        <HStack key={key} justifyContent="space-between" fontSize="14px">
          <Text color="gray.600">{labels[key] || key}</Text>
          <Text fontWeight="600">{value || "-"}</Text>
        </HStack>
      ))}
    </VStack>
  );
};

export const PayBillResultContent = ({
  resultState,
  currentItem,
  pendingPayment,
  isInitiatePending,
  isVerifyPending,
  payloadLabels,
  submittedPayload,
  formatCurrency,
  onBack,
  onProceedToCheckout,
  onVerifyPayment,
  onConfirm,
}) => {
  return (
    <VStack spacing="12px" py="10px">
      <Box
        as={resultState === "success" ? MdCheckCircle : MdErrorOutline}
        color={
          resultState === "success"
            ? "green.500"
            : isInitiatePending || resultState === "pending"
              ? "yellow.500"
              : "red.500"
        }
        boxSize="56px"
      />
      <Text fontWeight="700" fontSize="18px">
        {resultState === "success"
          ? `${formatItemLabel(currentItem)} Payment Successful`
          : resultState === "pending"
            ? "Complete Payment"
            : "Payment Failed"}
      </Text>
      <Text color="gray.600" textAlign="center" fontSize="14px">
        {resultState === "success"
          ? "Your order has been placed successfully."
          : resultState === "pending"
            ? "Review amount breakdown, proceed to checkout. Complete the payment."
            : "Review and try again."}
      </Text>
      {resultState === "pending" && pendingPayment && (
        <VStack spacing="8px" align="stretch" w="100%" mt="8px">
          <HStack justifyContent="space-between" fontSize="14px">
            <Text color="gray.600">Product Amount</Text>
            <Text fontWeight="600">
              {formatCurrency(pendingPayment.baseAmount)}
            </Text>
          </HStack>
          <HStack justifyContent="space-between" fontSize="14px">
            <Text color="gray.600">Markup / Service Fee</Text>
            <Text fontWeight="600">
              {formatCurrency(pendingPayment.markupAmount)}
            </Text>
          </HStack>
          <HStack justifyContent="space-between" fontSize="14px">
            <Text color="gray.600">Total Payable</Text>
            <Text fontWeight="700">
              {formatCurrency(
                pendingPayment.finalAmount ?? pendingPayment.chargedAmount,
              )}
            </Text>
          </HStack>
        </VStack>
      )}
      <ResultDetails
        submittedPayload={submittedPayload}
        payloadLabels={payloadLabels}
      />
      <HStack pt="8px">
        {(resultState === "error" || resultState === "pending") && (
          <Button
            borderRadius={"20px"}
            variant="outline"
            onClick={onBack}
            isDisabled={isVerifyPending}
          >
            Back
          </Button>
        )}
        {resultState === "pending" ? (
          <>
            <Button
              colorScheme="primary"
              onClick={onProceedToCheckout}
              isLoading={isVerifyPending}
              isDisabled={isVerifyPending}
            >
              Proceed to Checkout
            </Button>
          </>
        ) : (
          <Button colorScheme="primary" onClick={onConfirm}>
            Confirm
          </Button>
        )}
      </HStack>
    </VStack>
  );
};
